import { fmt } from "../../services/formatting";

export default function SimplifiedSummary({
  bancaBase,
  lucro,
  lucroDia,
  platformCountLabel,
  resultTone,
  displayCurrency,
}) {
  return (
    <section className="simple-hero">
      <div className="simple-hero__content">
        <div className="simple-section-label">Resumo da banca</div>
        <div className="simple-profit-stack" aria-label="Lucros da banca">
          <div className={`simple-profit simple-profit--${resultTone}`}>
            <div className="simple-profit__label">Lucro total</div>
            <div className="simple-profit__value">
              <span>{lucro >= 0 ? "+" : ""}</span>
              {fmt(lucro, displayCurrency)}
            </div>
          </div>
          <div
            className={`simple-profit simple-profit--${
              lucroDia >= 0 ? "positive" : "negative"
            }`}
          >
            <div className="simple-profit__label">Lucro do dia</div>
            <div className="simple-profit__value">
              <span>{lucroDia >= 0 ? "+" : ""}</span>
              {fmt(lucroDia, displayCurrency)}
            </div>
          </div>
        </div>
        <div className="simple-profit__caption">
          Saques e depositos ajustam o saldo sem interferir no lucro.
        </div>
      </div>
      <div className="simple-hero__meta" aria-label="Indicadores da banca">
        <div className="simple-metric">
          <div className="simple-metric__label">Banca base</div>
          <div className="simple-metric__value">{fmt(bancaBase, displayCurrency)}</div>
        </div>
        <div className="simple-metric">
          <div className="simple-metric__label">Distribuicao</div>
          <div className="simple-metric__value">{platformCountLabel}</div>
        </div>
      </div>
    </section>
  );
}
